const transformDataForMatrix = (leads, t) => {
    const transformedLeads = [];
    const headers = new Set();

    // First pass: collect all unique custom field keys
    leads?.forEach(lead => {
        if (typeof lead.CustomField === 'string') {
            headers.add(t("CustomField"));
        } else if (Array.isArray(lead.CustomField)) {
            lead.CustomField.forEach(field => {
                headers.add(field.key);
            });
        } else if (typeof lead.CustomField === 'object' && lead.CustomField !== null) {
            headers.add(lead.CustomField.key);
        }
    });

    // Second pass: transform each lead
    leads.forEach(lead => {
        const transformedLead = {};
        delete transformedLead.CustomField; // Remove the original CustomField
        
        headers.forEach(header => {
            if (typeof lead.CustomField === 'string') {
                if (header === t("CustomField")) {
                    transformedLead[header] = lead.CustomField;
                } else {
                    transformedLead[header] = null;
                }
            } else if (Array.isArray(lead.CustomField)) {
                const field = lead.CustomField.find(field => field.key === header);
                transformedLead[header] = field ? field.value : null;
            } else if (typeof lead.CustomField === 'object' && lead.CustomField !== null) {
                if (lead.CustomField.key === header) {
                    transformedLead[header] = lead.CustomField.value;
                } else {
                    transformedLead[header] = null;
                }
            } else {
                transformedLead[header] = null;
            }
        });

        transformedLeads.push(transformedLead);
    });

    return { headers: Array.from(headers), data: transformedLeads };
};

export { transformDataForMatrix };
